export const IMAGE_MIN_SIZE = 20 as const
export const IMAGE_MAX_SIZE = 100000 as const
export const IMAGE_THROTTLE_WAIT_TIME = 16 as const
